<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('reviews.editReview') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <label>{{ $t('reviews.generalRate') }}</label>
              <v-rating
                v-model="formData.generalRate"
                length="5"
                size="32"
                color="accent"
                :rules="[v => !!v || $t('validation.required')]"
              />
            </v-col>
          </v-row>

          <template v-if="formData.generalRate < 5">
            <v-row>
              <v-col cols="12">
                <label>{{ $t('reviews.communicationRate') }}</label>
                <v-rating
                  v-model="formData.communicationRate"
                  length="5"
                  size="32"
                  color="accent"
                  :rules="[v => !!v || $t('validation.required')]"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <label>{{ $t('reviews.punctualityRate') }}</label>
                <v-rating
                  v-model="formData.punctualityRate"
                  length="5"
                  size="32"
                  color="accent"
                  :rules="[v => !!v || $t('validation.required')]"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <label>{{ $t('reviews.serviceQualityRate') }}</label>
                <v-rating
                  v-model="formData.serviceQualityRate"
                  length="5"
                  size="32"
                  color="accent"
                  :rules="[v => !!v || $t('validation.required')]"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <label>{{ $t('reviews.accordanceWithArrangementsRate') }}</label>
                <v-rating
                  v-model="formData.accordanceWithArrangementsRate"
                  length="5"
                  size="32"
                  color="accent"
                  :rules="[v => !!v || $t('validation.required')]"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <label>{{ $t('reviews.paymentRate') }}</label>
                <v-rating
                  v-model="formData.paymentRate"
                  length="5"
                  size="32"
                  color="accent"
                  :rules="[v => !!v || $t('validation.required')]"
                />
              </v-col>
            </v-row>
          </template>

          <v-row>
            <v-col cols="12">
              <label>{{ $t('reviews.comment') }}</label>
              <v-textarea
                v-model="formData.comment"
                outlined
                dense
                :rules="[v => !!v || $t('validation.required'), v => (v && v.length <= 1000) || $t('validation.maxLength', { max: 1000 })]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">{{ $t('common.cancel') }}</v-btn>
        <v-btn color="primary" :disabled="!valid" :loading="loading" @click="save">{{ $t('common.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'EditReviewDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    review: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      valid: false,
      loading: false,
      formData: {
        reviewId: null,
        generalRate: 5,
        communicationRate: null,
        punctualityRate: null,
        serviceQualityRate: null,
        accordanceWithArrangementsRate: null,
        paymentRate: null,
        comment: ''
      }
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    review: {
      immediate: true,
      handler (val) {
        if (val) {
          this.formData = {
            reviewId: val.reviewId,
            generalRate: val.review.generalRate,
            communicationRate: val.review.communicationRate,
            punctualityRate: val.review.punctualityRate,
            serviceQualityRate: val.review.serviceQualityRate,
            accordanceWithArrangementsRate: val.review.accordanceWithArrangementsRate,
            paymentRate: val.review.paymentRate,
            comment: val.review.comment
          }
        }
      }
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    async save () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.loading = true
      try {
        await Service.put('/TSLReview/EditReview', this.formData)
        this.$emit('review-updated')
        this.close()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
